export default [
  {
    answer: 1,
    questions: [
      'Биоинформатика — это информатика, которую ведёт учитель биологии.',
      'Биоинформатика — это наука на стыке математики, программирования и биологии.',
    ],
  },
  {
    answer: 1,
    questions: [
      'Нет смысла читать отзывы, у меня свое мнение.',
      'В отзывах на проверенных сайтах можно найти много полезной информаци.',
    ],
  },
  {
    answer: 1,
    questions: [
      'Когда подключаешь новое устройство, пароль производителя лучше не менять — так его точно не забудешь.',
      'При подключении нового устройства придумай для него новый пароль.',
    ],
  },
  {
    answer: 0,
    questions: [
      'Если тебе показалось, что от имени друга тебе пишет мошенник, лучше перестраховаться и сразу позвонить другу по телефону.',
      'Если тебе показалось, что от имени друга тебе пишет мошенник, лучше сразу напрямую задать ему вопрос, мошенник ли он.',
    ],
  },
]
